import {match} from 'ts-pattern';

import {FinancingSection} from '../types/FinancingSection';

export type SavingSectionCounts = Record<FinancingSection, number>;

/**
 * Reference-counts the saves in flight for one section.
 *
 * A section has more than one save producer — the queued draft save, the configuration dialog and
 * the template card each report their own progress — so a plain boolean lets whichever save
 * finishes first report the section as idle while another one is still running. The count returns to
 * zero only once every producer reported its save as finished.
 *
 * A finished report without a matching started one leaves the count at zero instead of taking it
 * negative, which would otherwise keep the section saving for the rest of the page's life.
 */
export function applySavingSectionChange(
  currentCounts: SavingSectionCounts,
  section: FinancingSection,
  isSaving: boolean
): SavingSectionCounts {
  const nextCount = match(isSaving)
    .with(true, () => currentCounts[section] + 1)
    .with(false, () => Math.max(currentCounts[section] - 1, 0))
    .exhaustive();

  return {...currentCounts, [section]: nextCount};
}
